import { BsExclamationTriangle } from 'react-icons/bs';

import { capitalize } from '~/shared/utils/string';

type EnvironmentBannerProps = {
  environment: string;
};

export function EnvironmentBanner({ environment }: EnvironmentBannerProps) {
  return (
    <div className="flex bg-amber-500 text-white w-fit rounded-full px-4 py-1.5 whitespace-nowrap items-center gap-2">
      <BsExclamationTriangle size={14} />
      <span className="text-white font-semibold text-xs uppercase">
        {capitalize(environment)}
      </span>
    </div>
  );
}
